<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('purchase_invoice') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/po/invoice" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                {{$t('export_excel')}}
            </button>
            <div class="pull-right">
                <div class="form-inline">
                    <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('invoice_no')" v-model="query.Text" @keypress.enter="toList"/>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.FromDate" />
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.ToDate" />
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <VendorSelector :place="$t('all')" :is-all="true" @select="venSelected"></VendorSelector>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <select class="form-control form-control-sm" v-model="query.Status" @change="toList">
                                    <option value="">{{$t('all')}}</option>
                                    <option value="Draft">Draft</option>
                                    <option value="Posted">Posted</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <select class="form-control form-control-sm" v-model="query.PStatus" @change="statusChange">
                                    <option value="">{{$t('all')}}</option>
                                    <option value="Not Paid">Not Paid</option>
                                    <option value="Partially Paid">Partially Paid</option>
                                    <option value="Paid">Paid</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList">
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                    {{$t('search')}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                        <tr>
                            <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('Num')">{{ $t('bill_code') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('Date')">{{ $t('date') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('DueDate')">{{ $t('due_date') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('VendorName')">{{ $t('vendor') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('DocSource')">{{ $t('type') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field" @click="onSort('DocSourceNo')">{{ $t('ref_num') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting" style="width: 110px;">
                                <span class="sort-field" @click="onSort('GrandTotal')">{{ $t('amount') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting" style="width: 110px;">
                                <span class="sort-field" @click="onSort('Discount')">{{ $t('discount') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting" style="width: 130px;">
                                <span class="sort-field" @click="onSort('PaidAmount')">{{ $t('pay_amount') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting" style="width: 110px;">
                                <span class="sort-field" @click="onSort('Balance')">{{ $t('balance') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting" style="width: 80px;">
                                <span class="sort-field" @click="onSort('Status')">{{ $t('status') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting" style="width: 110px;">
                                <span class="sort-field" @click="onSort('PaidStatus')">{{ $t('payment_status') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret, index) in list" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>
                                <router-link :to="{name: 'po_invoice_view', params: {id: ret.Id}}">{{ret.Num}}</router-link>
                            </td>
                            <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                            <td>{{$format(ret.DueDate, 'DD/MM/YYYY')}}</td>
                            <td>{{ret.VendorName}}</td>
                            <td>{{ret.DocSource}}</td>
                            <td>{{ret.DocSourceNo}}</td>
                            <td class="text-right">{{$money(ret.GrandTotal)}}</td>
                            <td class="text-right">{{$money(ret.Discount)}}</td>
                            <td class="text-right">{{$money(ret.PaidAmount)}}</td>
                            <td class="text-right">{{$money(ret.Balance)}}</td>
                            <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                            <td class="cell-badge" v-html="$statusLabel(ret.PaidStatus)"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { VendorSelector } from '../Vendors';
    export default {
        components: { VendorSelector },
        data: function(){
            return {
                query:{
                    Text: '',
                    FromDate: '',
                    ToDate: '',
                    IsFilterDate: false,
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    Status: '',
                    PStatus: 'Not Paid',
                    Statuses: ['Not Paid','Partially Paid'],
                    SortType: '',
                    SortField: ''
                },
                list: []
            }
        },
        created: function(){
            this.toList();
        },
        methods: {
            toList(){
                let loading = this.$loading.show();
                this.$api().post('po/invoices', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.list = res.data.Data;
                        this.query.Total = res.data.Total;
                    }
                }).finally(function() { loading.hide(); });
            },
            exportExcel(){
                var loading = this.$loading.show();
                this.$api()({
                    url: this.$base() + 'po/invoices/export/excel',
                    method: 'post',
                    data: this.query,
                    responseType: 'blob'
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'po-invoice.xlsx');
                    document.body.appendChild(link);
                    link.click();
                }).finally(function(){ loading.hide();});
            },
            statusChange(){
                if(this.query.PStatus == '') this.query.Statuses = [];
                else if(this.query.PStatus == 'Not Paid') this.query.Statuses = ['Not Paid','Partially Paid'];
                else this.query.Statuses = [this.query.PStatus];
                this.toList();
            },
            onSort(field){
                this.query.SortField = field;
                if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
                else this.query.SortType = 'ASC';
                this.toList();
            },
            paging(e){
                this.query.Page = e;
                this.toList();
            },
            venSelected(e){
                if(e == null) this.query.VendorId = '';
                else this.query.VendorId = e.Id;
                this.toList();
            }
        }
    }
</script>
<style scoped>
    .max-width{
        width: 180px;
    }
</style>
